import * as React from 'react'

type Props = {
  active: boolean; percent: number;
}
const Star = ({active, percent}: Props) => {
  return (<div
    style={{
      width: !active
        ? '0%'
        : (isNaN(percent) || percent <= 0 ? '0' : percent) + '%'
    }}
    className={active || percent > 1 ? 'on' : 'off'}>
    <svg
      fill="none"
      height="25"
      viewBox="0 0 25 25"
      width="25"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 1.95297L15.1138 8.2373C15.2218 8.49698 15.466 8.67441 15.7464 8.69688L22.5308 9.24079L17.3618 13.6686C17.1482 13.8516 17.0549 14.1387 17.1202 14.4122L18.6994 21.0327L12.8909 17.4849C12.6509 17.3384 12.3491 17.3384 12.1091 17.4849L6.30061 21.0327L7.87984 14.4122C7.9451 14.1387 7.85182 13.8516 7.63822 13.6686L2.46918 9.24079L9.25364 8.69688C9.53399 8.67441 9.77819 8.49698 9.8862 8.2373L12.5 1.95297Z"
        fill="#BECF18" stroke="#BECF18"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"/>
    </svg>
  </div>)
}
const RatingStar = ({index, ratingAverage}) => {
  const percent = (ratingAverage - index > 1) ? 100 : (ratingAverage - index) * 100

  return (<div className="star">
    <Star
      active={false}
      percent={0}/>
    <Star
      active={true}
      percent={percent}/>
  </div>)
}
export default RatingStar
